module.exports = __webpack_public_path__ + "static/media/tone1_good.9d1609b2.svg";